/* Copyright 2024 Marimo. All rights reserved. */
import { Compartment } from "@codemirror/state";

export const historyCompartment = new Compartment();
